export default __webpack_public_path__ + "static/media/logo-back.ee95365c.svg";